const routesTitle: { [key: string]: string } = {
    "/": "Overview",
    "/users": "Users",
    "/users/pending": "Review New Users",
    "/reporting": "Reporting and Analysis",
    "/settings": "Settings",
    "/integrations": "Integrations",
    "/developers": "Developers",
    "/transactions": "Transactions",
    "/lenco-transactions": "Lenco Transactions",
    "/saving-groups": "Group Savings",
    "/requests": "Payment Requests",
    "/payment-link-reports": "Payment Link Reports",
    "/payment-link-liquidations": "Payment Link Liquidations",
    "/payment-link-refunds": "Payment Link Refunds",
    "/bill-payments": "Bill Payments",
    "/merchants": "Merchants",
    "/support-tickets": "Support Tickets",
    "/admin-users": "Admin Users",
    "/audit-trails": "Audit Trail",
};

export default routesTitle;
